/**
 * @file index.tsx
 *
 * @fileoverview Renders button for sharing on BlueSky.
 */

import {
  SharingButtonProps,
  SharingButtonCustom,
} from '~/jobiqo/components/SocialMedia/SharingButtons/components/Custom';
import BlueSkyColorIcon from '~/vcl/icons/color/Bluesky';
import { FormattedMessage } from 'react-intl';
import BlueSkyIcon from '~/vcl/icons/Bluesky';

export default function BlueSkySharingButton({
  url,
  coloredIcons = true,
  ...props
}: SharingButtonProps) {
  return (
    <SharingButtonCustom
      text={
        <FormattedMessage
          id="social_media_sharing_buttons_bluesky"
          defaultMessage="on BlueSky"
        />
      }
      urlToShare={url}
      href="https://bsky.app/intent/compose?text="
      IconComponent={coloredIcons ? BlueSkyColorIcon : BlueSkyIcon}
      {...props}
    />
  );
}
export { BlueSkySharingButton };
